var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 34,
    viewBox: "0 0 122 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_256_3624)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8707 15.0899C51.8759 14.8798 52.8252 15.3191 53.4395 16.0068C54.6866 17.4775 54.9286 23.5899 51.4664 23.8955C47.1665 24.2966 46.9431 15.8921 50.8707 15.0899ZM54.1654 13.3135C53.9234 12.9697 52.8624 11.8045 51.1127 11.5371C49.698 11.3079 47.818 11.7472 46.7942 12.473C40.9122 16.6371 43.1831 29.5303 51.2244 27.3146C52.8252 26.8753 53.9979 25.4618 54.1282 25.2517L54.1654 27.0854L58.6514 27.1045V4.54608H54.1654V13.3135Z",
    fill: "#848182"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.507 19.827C110.14 22.9214 107.348 25.5382 105.356 23.6854C104.425 22.8067 104.649 21.2214 105.71 20.591C106.231 20.2854 108.762 19.8652 109.507 19.827ZM102.136 12.7023L102.08 16.1023C102.787 15.7584 102.731 15.7966 103.904 15.2809C104.574 14.9944 105.393 14.7652 106.194 14.6888C108.111 14.536 109.6 14.9562 109.563 17.0573C108.297 17.7258 105.039 17.5157 103.364 18.3371C97.5939 21.164 101.484 29.9697 107.459 26.9517C108.762 26.3022 108.725 25.7674 109.563 25.0798L109.6 27.0663H113.77C113.77 24.6787 113.77 22.3101 113.77 19.9225C113.77 17.4584 113.974 15.5292 112.802 13.7337C110.698 10.5247 105.151 11.2888 102.136 12.7023Z",
    fill: "#848182"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3018 26.5124L73.3204 22.9405C72.5945 22.9978 70.8447 24.545 68.4994 23.6663C63.5294 21.8326 66.1168 12.6068 72.2966 15.5675C72.6689 15.7203 72.8737 15.8349 73.3204 16.0068V12.2248C70.9192 11.0214 67.1964 11.2315 64.8696 12.6641C60.4767 15.3765 59.788 23.2843 64.8324 26.4551C66.8799 27.754 71.2356 27.9641 73.3018 26.5124Z",
    fill: "#848182"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.063 27.0472H121.531L121.512 4.56519H117.063V27.0472Z",
    fill: "#848182"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.7217 27.0472H98.2635V11.9191H93.7217C93.7217 14.0966 93.7217 25.9202 93.7217 27.0472Z",
    fill: "#848182"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6215 0.0191193L31.7548 1.3562L24.4767 8.92024H8.74776L1.48827 1.3562L16.6215 0.0191193Z",
    fill: "#FDD12F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6215 33.9427L1.48827 32.6438L8.74776 25.0798H24.4767L31.7548 32.6438L16.6215 33.9427Z",
    fill: "#39C84F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0735931 17L1.48826 1.35619L8.74776 8.92023V25.0798L1.48826 32.6438L0.0735931 17Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1317 17L31.7543 1.35622L24.4762 8.92026V25.0798L31.7543 32.6439L33.1317 17Z",
    fill: "#C51F25"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9734 9.34048C97.2391 9.34048 98.2629 8.28992 98.2629 6.99104C98.2629 5.69216 97.2391 4.6416 95.9734 4.6416C94.7076 4.6416 93.6838 5.69216 93.6838 6.99104C93.6838 8.28992 94.7076 9.34048 95.9734 9.34048Z",
    fill: "#848182"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.5351 15.0899C83.5402 14.8798 84.4895 15.3191 85.1038 16.0068C86.351 17.4775 86.5929 23.5899 83.1307 23.8955C78.8122 24.2966 78.5889 15.8921 82.5351 15.0899ZM85.8111 13.3135C85.5692 12.9697 84.5082 11.8045 82.7584 11.5371C81.3438 11.3079 79.4637 11.7472 78.44 12.473C72.5579 16.6371 74.8288 29.5303 82.8701 27.3146C84.4709 26.8753 85.6436 25.4618 85.7925 25.2517L85.8298 27.0854L90.3158 27.1045V4.54608H85.8111V13.3135Z",
    fill: "#848182"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clip-path", {
    id: "clip0_256_3624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121.55,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEn);
export default __webpack_public_path__ + "static/media/LogoEn.27bf8b56be636ee371a792040853a95d.svg";
export { ForwardRef as ReactComponent };